module.exports = __webpack_public_path__ + "static/img/6-pd.d625c18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home/6-pd.png
// module id = 8aaL
// module chunks = 0